import * as THREE from 'three';

/** Orbit tuning scaled to layout span — large DXF plans need faster pan/zoom. */
export function getView3DOrbitProps(
  span: number,
  dragLayout: boolean,
  orthographic = false,
  options?: { topView?: boolean }
) {
  const safeSpan = Math.max(span, 500);
  const panSpeed = Math.min(2.8, Math.max(0.9, safeSpan / 5000));
  const zoomSpeed = Math.min(2.5, Math.max(1.0, safeSpan / 6000));
  const rotateSpeed = Math.min(0.9, Math.max(0.45, 4000 / safeSpan));

  const base = {
    makeDefault: true as const,
    enableDamping: true,
    dampingFactor: 0.06,
    rotateSpeed,
    panSpeed,
    zoomSpeed,
    screenSpacePanning: true,
    zoomToCursor: true,
    enableRotate: !dragLayout,
    enablePan: true,
    mouseButtons: dragLayout
      ? {
          LEFT: THREE.MOUSE.PAN,
          MIDDLE: THREE.MOUSE.DOLLY,
          RIGHT: THREE.MOUSE.PAN,
        }
      : {
          LEFT: THREE.MOUSE.ROTATE,
          MIDDLE: THREE.MOUSE.DOLLY,
          RIGHT: THREE.MOUSE.PAN,
        },
  };

  if (orthographic) {
    return {
      ...base,
      minZoom: 0.05,
      maxZoom: Math.max(80, safeSpan / 40),
    };
  }

  if (options?.topView) {
    return {
      ...base,
      // Dolly along the look axis toward the floor. zoomToCursor from overhead
      // barely changes distance and hits the mid-air target immediately.
      zoomToCursor: false,
      minPolarAngle: 0.001,
      maxPolarAngle: 0.35,
      minDistance: 8,
      maxDistance: safeSpan * 12,
    };
  }

  return {
    ...base,
    minPolarAngle: 0.12,
    maxPolarAngle: Math.PI / 2 - 0.04,
    minDistance: Math.max(1.5, safeSpan * 0.0015),
    maxDistance: safeSpan * 12,
  };
}
